module.exports = __webpack_public_path__ + "static/media/bg.51dbd361.png";